import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CountryProvider } from './contexts/CountryContext';
import { TenantScopeProvider } from './contexts/TenantScopeContext';
import ProtectedRoute from './components/layout/ProtectedRoute';
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import Dashboard from './pages/Dashboard';
import DashboardAdmin from './pages/DashboardAdmin';
import Agent from './pages/Agent';
import Carte from './pages/Carte';
import Tenants from './pages/Tenants';
import Admin from './pages/Admin';
import GestionSignalements from './pages/GestionSignalements';
import MonTenant from './pages/MonTenant';
import Signaler from './pages/Signaler';
import './App.css';

export default function App() {
  return (
    <CountryProvider>
      <AuthProvider>
        <TenantScopeProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signaler" element={<Signaler />} />
            <Route path="/signaler/:communeId" element={<Signaler />} />
            <Route path="/change-password" element={<ProtectedRoute allowMustChange><ChangePassword /></ProtectedRoute>} />
            <Route path="/" element={<ProtectedRoute roles={['superadmin']}><Dashboard /></ProtectedRoute>} />
            <Route path="/dashboard-admin" element={<ProtectedRoute roles={['superadmin', 'admin_region', 'admin_commune']}><DashboardAdmin /></ProtectedRoute>} />
            <Route path="/gestion" element={<ProtectedRoute roles={['superadmin', 'admin_region', 'admin_commune']}><GestionSignalements /></ProtectedRoute>} />
            <Route path="/mon-tenant" element={<ProtectedRoute roles={['admin_region', 'admin_commune']}><MonTenant /></ProtectedRoute>} />
            <Route path="/agent" element={<ProtectedRoute roles={['superadmin', 'admin_region', 'admin_commune', 'agent']}><Agent /></ProtectedRoute>} />
            <Route path="/carte" element={<ProtectedRoute><Carte /></ProtectedRoute>} />
            <Route path="/tenants" element={<ProtectedRoute roles={['superadmin']}><Tenants /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={['superadmin']}><Admin /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </TenantScopeProvider>
      </AuthProvider>
    </CountryProvider>
  );
}
